import login from './../login';
import logout from './../logout';

export default { login, logout };
